<template>
	<div class="Administration-box">
        <el-container>
            <!-- header -->
            <el-header>
                <h2 class="fl">{{ showType == 1?'四川创联国培职业技能等级认定中心':'海南创联国培职业技能等级认定中心'}}</h2>
				<div class="fr" style="color: #fff; font-size: 12px">
					<!-- <span class="icon-index" @click="goHome()">首页</span> -->
					<el-dropdown>
						<span class="icon-person">{{ userName }}</span>
						<el-dropdown-menu slot="dropdown">
							<!-- <el-dropdown-item>
								<div @click="jumpTo">
									<span style="color: #555; font-size: 14px">修改密码</span>
								</div>
							</el-dropdown-item> -->
							<el-dropdown-item divided @click.native="logout">退出登录</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>
				</div>
				<div class="clear"></div>
            </el-header>

            <el-container>
                <!-- left nav -->
                <el-aside style="background-color: #23262e" width="auto" class="pr">
                    <el-menu
                        class="el-menu-vertical-demo demo-style"
                        style="background-color: #23262e"
                        :default-active="$route.path"
                        router
                        :unique-opened="true"
                        @select="handleSelect"
                        :collapse="isCollapse"
                    >
                        <template style="">
                            <el-menu-item index="/introduce" :class="{active: curMenu == 1}">
                                <i class="el-icon-menu"></i>
                                <span slot="title">中心简介</span>
                            </el-menu-item>
                        </template>
                        <template style="">
                            <el-menu-item index="/notice" :class="{active: curMenu == 2}">
                                <i class="el-icon-menu"></i>
                                <span slot="title">通知公告</span>
                            </el-menu-item>
                        </template>
                        <template style="">
                            <el-menu-item index="/policy" :class="{active: curMenu == 3}">
                                <i class="el-icon-menu"></i>
                                <span slot="title">政策法规</span>
                            </el-menu-item>
                        </template>
                        <template style="">
                            <el-menu-item index="/recruit" :class="{active: curMenu == 4}">
                                <i class="el-icon-menu"></i>
                                <span slot="title">人才服务</span>
                            </el-menu-item>
                        </template>
                        <template style="">
                            <el-menu-item index="/occupation" :class="{active: curMenu == 5}">
                                <i class="el-icon-menu"></i>
                                <span slot="title">职业工种</span>
                            </el-menu-item>
                        </template>
                        <template style="">
                            <el-menu-item index="/company" :class="{active: curMenu == 6}">
                                <i class="el-icon-menu"></i>
                                <span slot="title">报名机构</span>
                            </el-menu-item>
                        </template>
                        <template style="">
                            <el-menu-item index="/student" :class="{active: curMenu == 7}">
                                <i class="el-icon-menu"></i>
                                <span slot="title">学员列表</span>
                            </el-menu-item>
                        </template>
                        <template style="">
                            <el-menu-item index="/class" :class="{active: curMenu == 8}">
                                <i class="el-icon-menu"></i>
                                <span slot="title">班级管理</span>
                            </el-menu-item>
                        </template>
                    </el-menu>
                </el-aside>
                <!-- 左侧导航收缩按钮 -->
                <el-radio-group v-model="isCollapse" class="pa" :class="{ put: isCollapse == true}">
                    <img
                        src="../../static/images/RightMenu.jpg"
                        class="sider_logo"
                        id="sider_logo"
                        alt=""
                        @click="closeNav()"
                    />
                </el-radio-group>

                <!-- main -->
				<el-main v-if="collapsed">

                    <router-view></router-view>

				</el-main>
                <el-main v-else>
                    这里是首页

                </el-main>

            </el-container>
        </el-container>

        <!-- 修改密码的弹窗 -->
		<el-dialog title="修改密码" :visible.sync="showModifyPassword" width="30%">
			<v_modifyPassword ref="appForm"></v_modifyPassword>
		</el-dialog>
	</div>
</template>
<style scoped>
.Administration-box{
    position: fixed;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    z-index: auto;
}
.el-container{
    width: 100%;
    height: 100%;
    overflow: hidden;
}
.el-main{
    padding: 30px;
}
.el-aside::-webkit-scrollbar{
    height: 0;
    width: 0;
}
.el-radio-group{
    left: 150px;
    top: 60px;
    cursor: pointer;
    -webkit-transition: all .45s;
    transition: all .45s;
}
.put{
    left: 64px;
}
.el-radio-group img{
    display: block;
    width: 16px;
    height: 14px;
    padding: 8px 7px;
}
.el-header h2{
    font-size: 20px;
    color: #ffffff;
    font-weight: bold;
}
.echartsBox h2 {
	font-weight: bold;
}
</style>
<script>
import modifyPassword from "./modifyPassword.vue";
export default {
	data: function () {
		return {
			defaultActiveIndex: ["0"],
			menuList: [],
			monsData: [],
			certMonsData: [],
			certCountsData: [],
			countsData: [],
			classCounts: "",
			certCounts: "",
			studentCounts: "",
			userName: "",
			collapsed: false,
			isCollapse: false,
			welcome: true,
			label: true,
			showModifyPassword: false,
			jjxh: process.env.NODE_ENV,
            curMenu: 1,//当前选中路由
			showType: 1
		};
	},
	components: {
		v_modifyPassword: modifyPassword,
	},
	methods: {
        //初始化
		getData() {
			
		},
		// 	index: 选中菜单项的 index, indexPath: 选中菜单项的 index path
		handleSelect(index) {
			this.collapsed = true;
		},
		// 个人中心  修改密码
		jumpTo() {
			this.showModifyPassword = true;
		},
		closeModifyPassword() {
			this.showModifyPassword = false;
			console.info(this.showModifyPassword);
		},
		// 退出
		logout() {
			let that = this;
			this.$confirm("确认退出吗?", "提示", {
				confirmButtonClass: "el-button--warning",
			})
				.then(() => {
					this.$api.post("/login/logout", {}, (r) => {
						if (r.status == 0) {
							window.localStorage.removeItem("username");
							// this.$router.push("/login");
                            this.$router.push({
                                path: "/login",
                            });
						}
					});
				})
				.catch(() => {});
		},
		// goHome() {
		// 	this.$router.push({ path: "/main" });
		// 	location.reload();
		// },
        //关闭左侧导航按钮
		closeNav() {
			this.isCollapse = !this.isCollapse;
			var sider_logo = document.getElementById("sider_logo");
			if (this.isCollapse) {
				sider_logo.src = "../../static/images/LeftMenu.jpg";
				sider_logo.style.float = "right";
			} else {
				sider_logo.src = "../../static/images/RightMenu.jpg";
				sider_logo.style.float = "right";
			}
		},
        //当前选中路由
        showMenuActive(route) {
            if (route.meta && route.meta.mainMenuIndex) {
                this.curMenu = route.meta.mainMenuIndex;
            }
        },


	},
    created() {
        this.showMenuActive(this.$route);
	},
	watch: {
		$route(to, from) {
			//监听路由是否变化
			this.showMenuActive(this.$route);
			// this.dialogVisible = false;
		},
	},
    mounted() {
		var domain = window.location.hostname
		// 1四川2海南
		if (domain == "hnjnrd.scjxjypx.com") {
			this.showType = 2
		}
		// 登录失效返回登录页
		if (!window.localStorage.getItem("username")) {
			this.$router.push({ path: "/login" });
		}
        //登录未失效，cookie中获取用户信息
        this.userName = window.localStorage.getItem("username");
		var url = window.location.href;
		if (url.split("#")[1] == "/main") {
		} else {
			this.collapsed = true;
		}
		
	},


};
</script>

<style>
@import "../../static/css/index.css";
.el-menu-item:focus,
.el-menu-item:hover {
	background-color: rgb(179 149 33);
}
.demo-style .el-menu-item {
	color: #fff;
}
.demo-style .el-menu-item.active{
    background: rgb(179 149 33);
}
.demo-style .el-menu-item.active i{
    color: inherit;
}
.el-menu {
	border-right: none;
	background-color: rgb(35, 38, 46);
}
.icon-person {
	background: url(../../static/images/el-icon-person.png) left center no-repeat;
	display: inline-block;
	background-size: 24px 24px;
	padding-left: 30px;
	color: #fff;
	cursor: pointer;
}
.icon-index {
	background: url(../../static/images/icon-index.png) left center no-repeat;
	display: inline-block;
	background-size: 24px 24px;
	padding-left: 30px;
	margin: 0 20px;
	font-size: 14px;
	cursor: pointer;
	color: #fff;
}
.homeDiv ul li {
	width: 30%;
	height: 100px;
	float: left;
	margin-right: 3%;
}
.homeDiv ul li div {
	margin-top: 18px;
}
.homeDiv ul li div p {
	color: #fff;
}
.homeDiv ul li .num {
	font-size: 28px;
	font-weight: bold;
}
.homeDiv ul .li {
	background: #59cd7c;
}
.homeDiv ul .li2 {
	background: #fbd543;
}
.homeDiv ul .li3 {
	background: #fb6260;
}

</style>



// WEBPACK FOOTER //
// src/views/home.vue